export const portlets = {};

export const registerPortlets = otherPortlets => Object.assign(portlets, otherPortlets);

export const directRequire = requiredPortlets => requiredPortlets.map(portlet => portlets[portlet]);

export const require = (requiredPortlets, callback) => {
    Promise.all(requiredPortlets.map(portlet => portlets[portlet])).then(args => callback(...args));
};
